export default __webpack_public_path__ + "static/media/Database.f546480a.svg";